<template lang="pug">
#header.header.home-header(:class="{ 'home-header-light': isLightHeader, 'has-service-dashboard-tabs': showHeaderTabs }")
  .header-wrapper
    div.left.p-l-0(:class="{ 'marketing-navigation': !inAnyDashboard && !workspaceMode }")
      div.logo-wrapper(v-show="!workspaceMode")
        div
          NuxtLink.icon-wrapper(to="/" :aria-label="$t('site_name')")
            span.logo
        div.brand-name.flex.items-center.gap-2
          NuxtLink(v-if="!inAnyDashboard" to="/")
            h1.site-name {{ $t('site_name') }}
        NuxtLink.ai-guide-header-link(v-if="!inAnyDashboard" to="/ai-guide" :aria-current="$route.path === '/ai-guide' ? 'page' : undefined")
          span {{ locale === 'zh' ? 'AI指南' : 'AI Guide' }}
        NuxtLink.ai-guide-header-link.teams-header-link(v-if="!inAnyDashboard" to="/org" :aria-current="$route.path === '/org' ? 'page' : undefined")
          span {{ $t('header.org') }}
        NuxtLink.ai-guide-header-link.dedicated-header-link(v-if="!inAnyDashboard" to="/dedicated-servers" :aria-current="$route.path === '/dedicated-servers' ? 'page' : undefined")
          span {{ locale === 'zh' ? '专线' : 'Dedicated Lines' }}
        NuxtLink.ai-guide-header-link.pandacore-header-link(v-if="!inAnyDashboard" to="/pandacore" :aria-current="$route.path === '/pandacore' ? 'page' : undefined")
          span {{ $t('pandacore.nav') }}
      div.logo-wrapper(v-show="workspaceMode")
        NuxtLink.ml-2(to="/") HOME
      div.divider.hide-for-small(v-if="inDashboard && userService.hasService")
      div(v-if="inDashboard && userService.hasService")
        ServiceCateSelector
      nav.dashboard-service-tabs.dashboard-service-tabs-desktop(
        v-if="showHeaderTabs" ref="desktopTabList" :aria-label="headerTabsLabel"
        :style="desktopTabMotion.style.value"
        :class="{ 'tabs-measured': desktopTabMotion.measured.value, 'tabs-hovering': desktopTabMotion.hovered.value !== null }"
        @pointerenter="desktopTabMotion.move" @pointermove="desktopTabMotion.move"
        @pointerleave="desktopTabMotion.clearHover" @pointercancel="desktopTabMotion.clearHover"
        @scroll="desktopTabMotion.clearHover" @click="desktopTabMotion.clickGap"
      )
        NuxtLink.dashboard-service-tab(
          v-for="tab in headerTabs"
          :key="tab.value"
          :to="getHeaderTabLink(tab.value)"
          :class="{ 'is-active': currentHeaderTab === tab.value, 'is-hovered': desktopTabMotion.hovered.value === tab.value }"
          :data-dashboard-tab="tab.value"
          :aria-label="$t(tab.labelKey)"
          :aria-current="currentHeaderTab === tab.value ? 'page' : undefined"
        )
          Icon.dashboard-service-tab-icon(v-if="typeof tab.icon === 'string'" :name="tab.icon")
          component.dashboard-service-tab-icon(v-else :is="tab.icon" aria-hidden="true")
          span.dashboard-service-tab-label {{ $t(tab.labelKey) }}
    div.right.mr-2
      nav.flex.items-center
        ul.menu.flex.items-center(class="gap-x-1 md:gap-x-4 text-xs")
          li.menu-item.lang-switcher.p-0.flex.items-center
            LangSwitcher
          li.menu-item.always-primary.p-0
            NuxtLink(:to="pricingLink") {{ $t('header.pricing') }}
          li.menu-item.always-primary.p-0
            NuxtLink(:to="dlLink") {{ $t('header.dlandguide') }}
          li.menu-item.menu-item-wrapper.p-0(v-if="!inDashboard && !showDashboardLink")
            SignButton(defaultState="login" buttonStyle="ghost")

          //- Switch between navigation components based on useNewNav flag
          //- You can change this to true to use the new NavigationMenu component
          li.p-0.pl-0.ml-0(v-if="showDashboardLink" style="margin-left: 0;")
            HeaderNavigationMenu(
              :is-light-header="isLightHeader"
              :show-dashboard-link="showDashboardLink"
              :dashboard-link="dashboardLink"
              :user-id="userId"
              :bill-link="billLink"
              :setting-link="settingLink"
              :support-link="supportLink"
              :ref-link="refLink"
              :profile-link="profileLink"
              :top-up-link="topUpLink"
              @logout="logout"
            )
            //- HeaderNavigationDropdown(
            //-   v-else
            //-   :show-dashboard-link="showDashboardLink"
            //-   :dashboard-link="dashboardLink"
            //-   :user-id="userId"
            //-   :bill-link="billLink"
            //-   :setting-link="settingLink"
            //-   :support-link="supportLink"
            //-   :ticket-link="ticketLink"
            //-   :ref-link="refLink"
            //-   :profile-link="profileLink"
            //-   :top-up-link="topUpLink"
            //-   @logout="logout"
            //- )
  nav.dashboard-service-tabs.dashboard-service-tabs-mobile(
    v-if="showHeaderTabs" ref="mobileTabList" :aria-label="headerTabsLabel"
    :style="mobileTabMotion.style.value"
    :class="{ 'tabs-measured': mobileTabMotion.measured.value, 'tabs-hovering': mobileTabMotion.hovered.value !== null }"
    @pointerenter="mobileTabMotion.move" @pointermove="mobileTabMotion.move"
    @pointerleave="mobileTabMotion.clearHover" @pointercancel="mobileTabMotion.clearHover"
    @scroll="mobileTabMotion.clearHover" @click="mobileTabMotion.clickGap"
  )
    NuxtLink.dashboard-service-tab(
      v-for="tab in headerTabs"
      :key="tab.value"
      :to="getHeaderTabLink(tab.value)"
      :class="{ 'is-active': currentHeaderTab === tab.value, 'is-hovered': mobileTabMotion.hovered.value === tab.value }"
      :data-dashboard-tab="tab.value"
      :aria-label="$t(tab.labelKey)"
      :aria-current="currentHeaderTab === tab.value ? 'page' : undefined"
    )
      Icon.dashboard-service-tab-icon(v-if="typeof tab.icon === 'string'" :name="tab.icon")
      component.dashboard-service-tab-icon(v-else :is="tab.icon" aria-hidden="true")
      span.dashboard-service-tab-label {{ $t(tab.labelKey) }}
  BigNews
</template>

<script lang="ts" setup>
import type { OrgDashboardTabItem } from '@/composables/org/useOrgDashboardTabs'
import {
  ORG_DASHBOARD_TABS,
  normalizeOrgDashboardTab,
  useOrgDashboardTabsVisible,
} from '@/composables/org/useOrgDashboardTabs'
// Components are auto-imported by Nuxt, no need for explicit imports
// Set this to true to use the new NavigationMenu component
// Set to false to use the old DropdownMenu component
const useNewNav = ref(true) // Change this to false to use the old navigation

const $i18n = useI18n()
const $t = $i18n.t
const locale = $i18n.locale
const $colorMode = useColorMode()

const $route = useRoute()
const user = useUser()
const userService = useUserService()
const visitorSession = useVisitorSession()
const userPref = useUserPref()
const $utils = useUtils()
const loading = ref(true)
const initSessionAndUserData = useInitSessionAndUserData()
const token = useCookie('jwt_token')
// console.log('$route.path', $route.path)

const inDashboard = computed(() => $route.path?.startsWith('/dashboard/'))
const inServiceDashboard = computed(() => /^\/dashboard\/[^/]+\/?$/.test($route.path || ''))
const inOrgDashboard = computed(() => /^\/orgdashboard\/[^/]+\/?$/.test($route.path || ''))
// The team dashboard keeps the same top-left as the service dashboard: logo + tabs, no marketing links.
const inAnyDashboard = computed(() => inDashboard.value || ($route.path || '').startsWith('/orgdashboard'))
const isLightHeader = computed(() => $colorMode.value === 'light')

const serviceDashboardTabs = [
  {
    value: 'details',
    labelKey: 'service_index.menu.overview',
    icon: 'solar:chart-2-bold-duotone',
  },
  {
    value: 'guides',
    labelKey: 'service_index.menu.guides',
    icon: 'solar:notebook-minimalistic-broken',
  },
  {
    value: 'settings',
    labelKey: 'service_index.menu.settings',
    icon: 'material-symbols:settings-ethernet-rounded',
  },
] as const

const orgTabsVisible = useOrgDashboardTabsVisible()
// The org page resolves membership/permission only after its own setup, so its tabs
// are client-rendered to keep the server markup and the hydration render identical.
const mounted = ref(false)
onMounted(() => {
  mounted.value = true
})

const showServiceDashboardTabs = computed(() => inServiceDashboard.value && userService.hasService)
const showOrgDashboardTabs = computed(() => mounted.value && inOrgDashboard.value && orgTabsVisible.value)

const headerTabs = computed<readonly OrgDashboardTabItem[]>(() => {
  if (showServiceDashboardTabs.value) return serviceDashboardTabs
  if (showOrgDashboardTabs.value) return ORG_DASHBOARD_TABS
  return []
})

const showHeaderTabs = computed(() => headerTabs.value.length > 0)

const headerTabsLabel = computed(() =>
  showOrgDashboardTabs.value ? $t('org.dashboard.title') : $t('dashboard_page.page_title'))

const currentHeaderTab = computed(() => {
  if (showOrgDashboardTabs.value) return normalizeOrgDashboardTab($route.query.tab)
  const tab = String($route.query.tab || 'details')
  return serviceDashboardTabs.some(item => item.value === tab) ? tab : 'details'
})

const getHeaderTabLink = (tab: string) => {
  const query = { ...$route.query }
  query.tab = tab
  if (showServiceDashboardTabs.value && tab !== 'guides') {
    delete query.os
    delete query.guideName
  }
  return {
    path: $route.path,
    query,
  }
}

const desktopTabList = ref<HTMLElement | null>(null)
const mobileTabList = ref<HTMLElement | null>(null)
const desktopTabMotion = useDashboardTabMotion(desktopTabList, () => currentHeaderTab.value)
const mobileTabMotion = useDashboardTabMotion(mobileTabList, () => currentHeaderTab.value)

const workspaceMode = computed(() => userPref.workspaceMode)

const userId = computed(() => {
  return user.id
})

const showDashboardLink = computed(() => {
  if (visitorSession.loggedIn) {
    return true
  }
  // return $utils.checkToken(token.value)
  return false
})

const dashboardLink = computed(() => {
  if (userId.value === -1) {
    return ''
  }
  return visitorSession.loggedIn ? `/dashboard/${userId.value}` : '/dashboard'
})

const billLink = computed(() => {
  return visitorSession.loggedIn && userId.value !== -1 ? `${dashboardLink.value}/billing` : ''
})

const pricingLink = computed(() => {
  return visitorSession.loggedIn && userId.value !== -1 ? `/pricing${userId.value !== -1 ? `?asUser=${userId.value}` : ''}` : '/pricing'
})

const dlLink = computed(() => {
  // if (showDashboardLink && userService.hasService) {
  //   return `${dashboardLink.value}?tab=guides`
  // }
  return '/download'
})

const settingLink = computed(() => {
  return visitorSession.loggedIn && userId.value !== -1 ? `${dashboardLink.value}/settings` : ''
})

const supportLink = computed(() => {
  return visitorSession.loggedIn && userId.value !== -1 ? `${dashboardLink.value}/support` : ''
})

const refLink = computed(() => {
  return '/my-ref'
})

const profileLink = computed(() => {
  return visitorSession.loggedIn && userId.value !== -1 ? `${dashboardLink.value}/profile` : ''
})

// Logout is now handled by the navigation components
const logout = () => {
  // This will be called by the navigation components
  // The actual logout logic is in those components
}

const topUpLink = computed(() => {
  if (user.extra?.suspend) {
    return undefined
  }
  const query = ['mode=topUp']
  if (userId.value !== -1) {
    query.push(`asUser=${userId.value}`)
  }
  return `/pricing?${query.join('&')}`
})

const goTo = (link?: string) => {
  if (!link) {
    return
  }
  navigateTo(link)
}

onMounted(async () => {
  // if (visitorSession.loggedIn) {
  //   return
  // }
  try {
    await useInitSessionAndUserData().init()
  } catch (e) {
    console.error(e)
  }
  // console.log('--->>>> visitorSession.loggedIn', visitorSession.loggedIn)
  // loading.value = true
  // loading.value = false
  visitorSession.tryBootIntercom()
})
</script>

<style lang="postcss" scoped>

.header {
  mix-blend-mode: normal;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  bottom: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  min-height: 64px;

  background: transparent;
  /* border-bottom: 1px solid rgba(255, 255, 255, 0.1); */

  /* Specular highlight */
  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg,
        transparent 0%,
        rgba(255, 255, 255, 0.3) 20%,
        rgba(255, 255, 255, 0.3) 80%,
        transparent 100%);
    opacity: 0;

    transition: opacity 0.25s ease-out;
  }

  /* Light mode adjustments */
  .light & {
    background: transparent;
    /* border-bottom: 1px solid rgba(0, 0, 0, 0.08); */

    &::before {
      background: linear-gradient(90deg,
          transparent 0%,
          rgba(255, 255, 255, 0.8) 20%,
          rgba(255, 255, 255, 0.8) 80%,
          transparent 100%);
    }
  }

  @media (max-width: 768px) {
    min-height: 48px;
  }

  z-index: 1000;

  a {
    text-decoration: none;
    color: var(--primary-color);

    &:visited {
      color: var(--primary-color);
    }
  }

}

.simple-service-switcher {
  margin: 0 10px;
}

.header-wrapper {
  align-items: center;
  color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 auto;
  padding: 5px;

  @media (max-width: 768px) {
    padding: 5px 0;
    /* font-size: 20px; */
    min-height: 48px;
  }

  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: auto;
  min-height: 64px;

  .left,
  .right {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* between service selector and site logo */
  .left {
    .divider {
      &:after {
        content: '/';
        color: var(--primary-color);
        font-size: 15px;
      }
    }
  }

  /* between color switcher and links */
  .right {
    /* padding-right: 1rem; */

    .divider {
      &:after {
        content: '|';
        color: var(--primary-color);
        font-size: 1.2rem;
        margin: 10px;

        @media (max-width: 375px) {
          /* font-size: 20px; */
          margin: 0px;
          padding-right: -15px;
        }
      }
    }
  }
}

.logo {
  background: url(https://alicloud-assets.oss-accelerate.aliyuncs.com/img/logo-color.svg) no-repeat center center;
  /* background: url(https://alicloud-assets.oss-accelerate.aliyuncs.com/img/logo.svg) no-repeat center top; */
  background-size: 100%;
  display: inline-block;
  height: 47px;
  width: 47px;
  margin: 0 10px 0 4px;

  @media (max-width: 768px) {
    height: 37px;
    width: 37px;
    margin: 5px 5px;
  }

  @media (max-width: 400px) {
    height: 31px;
    width: 31px;
    margin: 4px 4px;
  }

  align-items: center;
  display: flex;
  justify-content: flex-start;
  position: relative;
  display: inline-block;
}

.logo-wrapper {
  display: flex;
  justify-items: center;
  align-items: center;

  /* height: 47px; */
  /* Keep the logo and visible wordmark at their intended size. */
  div {
    display: flex;
    flex-shrink: 0;
  }

  .icon-wrapper {
    height: 47px;
    display: flex;
    align-items: center;
  }

  .site-name {
    color: var(--primary-color);
    font-size: 25px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Roboto, Arial, PingFang SC,
      Hiragino Sans GB, Microsoft Yahei, Microsoft Jhenghei, sans-serif;

    @media (max-width: 768px) {
      font-size: 15px;
      /* display: none; */
    }

    @media (max-width: 400px) {
      font-size: 13px;
    }

    letter-spacing: 0px;
    vertical-align: middle;
    display: inline-block;
    margin: 0;
  }

}

.dashboard-service-tabs {
  position: relative;
  isolation: isolate;
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  max-width: min(42vw, 34rem);
  margin-left: 0.75rem;
  padding: 0;
  overflow-x: auto;
  scrollbar-width: none;
  white-space: nowrap;
}

.dashboard-service-tabs::before,
.dashboard-service-tabs::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100px;
  border-radius: 0.38rem;
  pointer-events: none;
  transform-origin: top left;
  opacity: 0;
}

.dashboard-service-tabs::before {
  background: rgba(126, 211, 33, 0.13);
  height: var(--tab-active-height);
  transform: translate3d(var(--tab-active-x), var(--tab-active-y), 0) scaleX(var(--tab-active-scale));
  transition: transform var(--tab-active-duration) cubic-bezier(0.22, 1, 0.36, 1);
}

.dashboard-service-tabs::after {
  background: rgba(126, 211, 33, 0.08);
  height: var(--tab-hover-height);
  transform: translate3d(var(--tab-hover-x), var(--tab-hover-y), 0) scaleX(var(--tab-hover-scale));
  transition: opacity 120ms ease-out;
}

.dashboard-service-tabs.tabs-measured::before,
.dashboard-service-tabs.tabs-hovering::after {
  opacity: 1;
}

.dashboard-service-tabs.tabs-hovering::after {
  transition: transform var(--tab-hover-duration) cubic-bezier(0.22, 1, 0.36, 1), opacity 120ms ease-out;
}

.tabs-measured .dashboard-service-tab.is-active {
  background: transparent;
}

.dashboard-service-tabs::-webkit-scrollbar {
  display: none;
}

.header.home-header .dashboard-service-tabs-mobile {
  display: none;
}

:global(.dark) .dashboard-service-tabs {
  background: transparent;
}

.dashboard-service-tab {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.38rem;
  min-height: 2.05rem;
  padding: 0 0.65rem;
  border-radius: 0.38rem;
  color: var(--primary-color);
  font-size: 0.72rem;
  font-weight: 850;
  line-height: 1;
  text-decoration: none;
  transition:
    background-color 0.22s cubic-bezier(0.16, 1, 0.3, 1),
    color 0.22s cubic-bezier(0.16, 1, 0.3, 1),
    transform 0.22s cubic-bezier(0.16, 1, 0.3, 1);
}

.dashboard-service-tab.is-hovered,
.dashboard-service-tab.is-active {
  color: #2d5a27 !important;
}

.dashboard-service-tab.is-active {
  background: rgba(126, 211, 33, 0.13);
}

:global(.dark) .dashboard-service-tab.is-hovered,
:global(.dark) .dashboard-service-tab.is-active {
  color: #7ed321 !important;
}

.dashboard-service-tab:active {
  transform: translateY(1px) scale(0.985);
}

.dashboard-service-tab:focus-visible {
  outline: 2px solid rgba(126, 211, 33, 0.6);
  outline-offset: 2px;
}

.dashboard-service-tab-icon {
  width: 0.95rem;
  height: 0.95rem;
  flex: none;
}

.dashboard-service-tab-label {
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (prefers-reduced-motion: reduce) {
  .dashboard-service-tabs::before,
  .dashboard-service-tabs.tabs-hovering::after {
    transition: opacity 120ms ease-out;
  }

  .dashboard-service-tab {
    transition: none;
  }

  .dashboard-service-tab:active {
    transform: none;
  }
}


.menu-item {
  cursor: default;
  color: var(--primary-color);
  margin-left: 3px;
  margin-right: 3px;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  /* span {
    } */
  i {
    padding: 2.5px;
  }

  &.always-primary {
    a {
      color: var(--primary-color) !important;
      padding: 4px 8px;
      border-radius: 12px;
      position: relative;
      display: inline-block;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      font-size: 1.4rem;

      @media (max-width: 768px) {
        font-size: 0.8rem;
        padding: 3px 7px;
      }

      @media (max-width: 400px) {
        font-size: 0.72rem;
        padding: 2px 5px;
      }

      &:hover {
        transform: translateY(-1px);
        color: rgb(126, 211, 33) !important;
        text-shadow: 0 0 20px rgba(126, 211, 33, 0.3);
      }
    }
  }
}

.menu-item-wrapper {
  display: flex;
  align-items: center;
}

/* Hide the language switcher on phones to keep the top nav uncrowded */
@media (max-width: 480px) {
  .menu-item.lang-switcher {
    display: none;
  }
}

@media (max-width: 920px) {
  .dashboard-service-tabs {
    max-width: 36vw;
    margin-left: 0.4rem;
  }

  .dashboard-service-tab {
    padding: 0 0.48rem;
  }
}

@media (max-width: 520px) {
  .header.home-header .dashboard-service-tabs-desktop {
    display: none;
  }

  .header.home-header.has-service-dashboard-tabs {
    min-height: 92px;
  }

  .header.home-header.has-service-dashboard-tabs .header-wrapper {
    flex: 0 0 56px;
    height: 56px;
  }

  .header.home-header .dashboard-service-tabs-mobile {
    display: flex;
    align-items: center;
    flex: 0 0 36px;
    width: 100%;
    max-width: none;
    height: 36px;
    margin: 0;
    gap: 3px;
    padding: 3px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    justify-content: stretch;
    overflow-x: visible;
  }

  .header.home-header.home-header-light .dashboard-service-tabs-mobile {
    border-top-color: rgba(51, 65, 85, 0.12);
  }

  .header.home-header .dashboard-service-tabs-mobile .dashboard-service-tab {
    flex: 1 1 0;
    justify-content: center;
    gap: 0.24rem;
    min-width: 0;
    height: 29px;
    min-height: 0;
    padding: 0 0.42rem;
    font-size: 0.66rem;
  }

  .header.home-header .dashboard-service-tabs-mobile .dashboard-service-tab-label {
    min-width: 0;
  }
}

nav {
  .menu {
    color: var(--primary-color);
    list-style: none;
    padding-right: 5px;
    margin: 0;

    li:first-child {
      margin-left: 0;
    }

    /* margin-right: 5px; */
    &-item {
      font-size: 1.4rem;
      font-weight: 600;
      margin: 0px 3px;

      @media (max-width: 768px) {
        font-size: 0.95rem;
        margin: 0px 2px;
      }

      &.divider {
        /* width: 1px; */
        height: 20px;
        border-left: 1px solid var(--light-grey);
      }

      position: relative;
      cursor: pointer;

      &.hide-for-small {
        @media (max-width: 768px) {
          display: none;
        }
      }

      &::after {
        content: '';
        display: block;
        width: 100%;
        height: 3px;
        background-color: var(--logo-green);
        position: absolute;
        visibility: hidden;
        transform-origin: left;
        transform: scale(0);
        transition: 0.25s ease-out;
      }

      &:hover::after {
        visibility: visible;
        transform: scale(1);
      }

      &.color-switcher,
      &.lang-switcher,
      &.sign-up {
        &:hover {
          &::after {
            visibility: hidden;
          }
        }
      }

      &.sign-up {
        a {
          border: 1px solid red;
          border-radius: 4px;
          padding: 6px 12px;
          color: var(--button-text);
          border: solid 2px var(--button-text);
          font-weight: 700;
          font-size: 1.4rem;

          @media (max-width: 768px) {
            padding: 4px 10px;
            font-size: 0.8rem;
          }

          @media (max-width: 400px) {
            padding: 3px 8px;
            font-size: 0.72rem;
          }

          &:hover {
            background: var(--button-text);
            color: var(--button-bg);
            border-color: var(--button-bg);
          }
        }
      }

      &.sign-in,
      &.dashboard {
        margin-inline-start: 16px;
        /* font-size: 0px; */
        border-radius: 4px;

        &::after {
          visibility: visible;
          transform: scale(1);
        }

        a {
          /* text-decoration: underline; */
          color: var(--primary-color);
          /* margin-left: 1rem; */
          /* color: black; */
        }
      }

    }
  }
}

/* Header icon styles moved to navigation components */

.header.home-header {
  --header-nav-link-color: #a1a1a6;
  --header-nav-link-hover-color: #ededed;
  --lang-switcher-color: var(--header-nav-link-color);
  --lang-switcher-hover-color: var(--header-nav-link-hover-color);
  --lang-switcher-focus-color: rgba(126, 211, 33, 0.72);

  position: sticky;
  top: 0;
  right: 0;
  bottom: auto;
  left: 0;
  width: 100%;
  height: auto;
  min-height: 56px;
  border: 0;
  border-radius: 0;
  background: rgba(2, 4, 2, 0.72);
  box-shadow: none;
  -webkit-backdrop-filter: blur(12px) saturate(160%);
  backdrop-filter: blur(12px) saturate(160%);
  z-index: 1000;
}

.header.home-header::before {
  opacity: 0;
}

.header.home-header .header-wrapper {
  padding: 0 0.75rem;
  min-height: 56px;
}

.header.home-header .left,
.header.home-header .right,
.header.home-header nav,
.header.home-header nav .menu,
.header.home-header .menu-item,
.header.home-header .menu-item-wrapper {
  height: 100%;
  align-items: center;
}

.header.home-header nav,
.header.home-header nav .menu,
.header.home-header .menu-item,
.header.home-header .menu-item-wrapper,
.header.home-header .menu-item.always-primary a,
.header.home-header .menu-item-wrapper :deep(.log-in),
.header.home-header .menu-item-wrapper :deep(.log-in button) {
  display: inline-flex;
  align-items: center;
}

.header.home-header .menu-item.always-primary a,
.header.home-header .menu-item-wrapper :deep(.log-in button) {
  height: 2.25rem;
  line-height: 1;
}

.header.home-header a,
.header.home-header .site-name,
.header.home-header .menu-item,
.header.home-header nav .menu {
  color: #f5f7f1 !important;
}

.header.home-header .logo {
  width: 34px;
  height: 34px;
  margin: 0 0.45rem 0 0;
}

.header.home-header .logo-wrapper .icon-wrapper {
  height: 42px;
}

.header.home-header .logo-wrapper .site-name {
  font-size: 1.125rem;
  font-weight: 600;
}

.header.home-header .ai-guide-header-link {
  display: inline-flex;
  height: 2rem;
  align-items: center;
  margin-left: 0.75rem;
  padding-left: 0.75rem;
  color: var(--header-nav-link-color) !important;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  transition: color 0.15s cubic-bezier(0.22, 1, 0.36, 1);
}

.header.home-header .ai-guide-header-link:hover,
.header.home-header .ai-guide-header-link[aria-current='page'] {
  color: var(--header-nav-link-hover-color) !important;
}

.header.home-header .ai-guide-header-link:focus-visible {
  outline: 2px solid var(--header-nav-link-hover-color);
  outline-offset: 3px;
}

.header.home-header .left.marketing-navigation {
  container: header-marketing / inline-size;
  flex: 1 1 0;
  min-width: 0;
  justify-content: flex-start;
  overflow: visible;
}

.header.home-header .right {
  flex-shrink: 0;
}

.header.home-header .marketing-navigation .logo-wrapper {
  flex-shrink: 0;
}

.header.home-header .marketing-navigation .icon-wrapper {
  min-width: 44px;
  min-height: 44px;
}

/* Use the space left by account/navigation controls, including translated labels. */
@container header-marketing (max-width: 36rem) {
  .header.home-header .brand-name {
    display: none;
  }

  .header.home-header .ai-guide-header-link {
    margin-left: 0.45rem;
    padding-left: 0.45rem;
    font-size: 0.72rem;
  }
}

@container header-marketing (max-width: 24rem) {
  .header.home-header .pandacore-header-link {
    display: none;
  }
}

@container header-marketing (max-width: 19rem) {
  .header.home-header .dedicated-header-link {
    display: none;
  }
}

@container header-marketing (max-width: 12rem) {
  .header.home-header .teams-header-link {
    display: none;
  }
}

@container header-marketing (max-width: 8rem) {
  .header.home-header .ai-guide-header-link {
    display: none;
  }
}

.header.home-header .menu-item.always-primary a:hover,
.header.home-header .menu-item-wrapper :deep(.log-in button:hover) {
  color: var(--header-nav-link-hover-color) !important;
  background: transparent;
  text-shadow: none;
  transform: none;
}

.header.home-header .menu-item.always-primary a,
.header.home-header .menu-item-wrapper :deep(.log-in button) {
  color: var(--header-nav-link-color) !important;
  position: relative;
  justify-content: center;
  border: 0;
  border-radius: 12px;
  background: transparent;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.15s ease;
  padding: 4px 8px;
  font-family: var(--default-font);
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0;
  white-space: nowrap;
  word-break: keep-all;
  text-transform: none;
}

@media (min-width: 1024px) {
  .header.home-header .lang-switcher-button {
    width: 2.9rem;
    height: 2rem;
    font-size: 0.84rem;
  }

  .header.home-header .menu-item.always-primary a,
  .header.home-header .menu-item-wrapper :deep(.log-in button) {
    height: 2.25rem;
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;
  }

  html[lang^='zh'] .header.home-header .menu-item.always-primary a,
  html[lang^='zh'] .header.home-header .menu-item-wrapper :deep(.log-in button) {
    font-size: 1.02rem;
  }
}

.header.home-header .menu-item::after,
.header.home-header nav .menu-item::after {
  display: none;
}

@media (max-width: 768px) {
  .header.home-header {
    top: 0;
    left: 0;
    width: 100%;
    min-height: 56px;
    border-right: 0;
    border-left: 0;
    border-radius: 0;
  }

  .header.home-header .header-wrapper {
    padding: 0 0.5rem;
  }

  .header.home-header .logo-wrapper .brand-name {
    display: none;
  }

  .header.home-header .ai-guide-header-link {
    margin-left: 0.45rem;
    padding-left: 0.45rem;
    font-size: 0.72rem;
  }

  .header.home-header .menu-item.always-primary a,
  .header.home-header .menu-item-wrapper :deep(.log-in button) {
    font-size: 0.75rem;
    padding: 0.25rem 0.5rem;
  }
}

html[lang^='zh'] .header.home-header .menu-item.always-primary a,
html[lang^='zh'] .header.home-header .menu-item-wrapper :deep(.log-in button) {
  font-size: 0.92rem;
  letter-spacing: 0;
  text-transform: none;
}

@media (max-width: 768px) {
  html[lang^='zh'] .header.home-header .menu-item.always-primary a,
  html[lang^='zh'] .header.home-header .menu-item-wrapper :deep(.log-in button) {
    font-size: 0.84rem;
  }
}

@media (max-width: 480px) {
  .header.home-header .left {
    flex: 1 1 auto;
    justify-content: flex-start;
    overflow: hidden;
  }

  .header.home-header .right {
    flex: 0 0 auto;
    margin-right: 0.25rem;
  }

  .header.home-header .logo {
    margin-right: 0.35rem;
  }

  .header.home-header .logo-wrapper {
    min-width: 0;
  }

  .header.home-header nav .menu {
    column-gap: 0;
    flex-wrap: nowrap;
    padding-right: 0;
  }

  .header.home-header .menu-item {
    flex: 0 0 auto;
    margin-left: 1px;
    margin-right: 1px;
    padding-left: 0;
    padding-inline-start: 0;
  }

  .header.home-header .lang-switcher-button {
    width: 2.1rem;
  }

  .header.home-header .menu-item.always-primary a,
  .header.home-header .menu-item-wrapper :deep(.log-in button) {
    width: max-content;
    min-width: max-content;
    overflow-wrap: normal;
    padding: 0.25rem 0.2rem;
  }
}

.header.home-header .menu-item-wrapper :deep(.log-in button) {
  height: 2rem;
  padding: 0 0.875rem;
  border-radius: 8px;
  color: #ededed !important;
  box-shadow: inset 0 0 0 1px rgba(237, 237, 237, 0.16);
}

@media (max-width: 768px) {
  .header.home-header .menu-item-wrapper :deep(.log-in button) {
    height: 1.875rem;
    padding: 0 0.625rem;
  }
}

.light .header.home-header,
.header.home-header.home-header-light {
  --header-nav-link-color: #525252;
  --header-nav-link-hover-color: #171717;
  --lang-switcher-focus-color: rgba(45, 90, 39, 0.52);

  border-color: rgba(51, 65, 85, 0.15);
  background: rgba(244, 247, 249, 0.76);
  box-shadow: none;
}

.light .header.home-header .ai-guide-header-link,
.header.home-header.home-header-light .ai-guide-header-link {
  color: var(--header-nav-link-color) !important;
}

.light .header.home-header .ai-guide-header-link:hover,
.light .header.home-header .ai-guide-header-link[aria-current='page'],
.header.home-header.home-header-light .ai-guide-header-link:hover,
.header.home-header.home-header-light .ai-guide-header-link[aria-current='page'] {
  color: var(--header-nav-link-hover-color) !important;
}

.light .header.home-header a,
.light .header.home-header .site-name,
.light .header.home-header .menu-item,
.light .header.home-header nav .menu,
.header.home-header.home-header-light a,
.header.home-header.home-header-light .site-name,
.header.home-header.home-header-light .menu-item,
.header.home-header.home-header-light nav .menu {
  color: #1e293b !important;
}

.light .header.home-header .menu-item.always-primary a,
.light .header.home-header .menu-item-wrapper :deep(.log-in button),
.header.home-header.home-header-light .menu-item.always-primary a,
.header.home-header.home-header-light .menu-item-wrapper :deep(.log-in button) {
  color: var(--header-nav-link-color) !important;
}

.light .header.home-header .menu-item-wrapper :deep(.log-in button),
.header.home-header.home-header-light .menu-item-wrapper :deep(.log-in button) {
  color: #171717 !important;
  box-shadow: inset 0 0 0 1px rgba(23, 23, 23, 0.16);
}

.light .header.home-header .menu-item.always-primary a:hover,
.light .header.home-header .menu-item-wrapper :deep(.log-in button:hover),
.header.home-header.home-header-light .menu-item.always-primary a:hover,
.header.home-header.home-header-light .menu-item-wrapper :deep(.log-in button:hover) {
  color: var(--header-nav-link-hover-color) !important;
}

</style>
